import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SystemGetAuthMenuList } from "@/service/system";
import store2 from "store2";
import { boolStr2Boolean } from "@/utils/util";
 

// 保留原有的getMenuList方法以保持兼容性
export const getMenuList = createAsyncThunk("app/menuList", async () => {
  try {
    return await SystemGetAuthMenuList();
  } catch (error) {
    console.log(error);
  }
});

export const appSlice = createSlice({
  name: "app",
  initialState: {
    collapsed: false,
    menuList: store2("menus") || [],
    levelList: [],
    identityList: [],
    messageList: [],
    loading: false
  },
  reducers: {
    toggleCollapsed: (state, action) => {
      console.log(action);
      return (state = { ...state, ...action.payload });
    },
    toggleLevelList: (state, action) => {
      return (state = { ...state, ...action.payload });
    },
    toggleIdentityList: (state, action) => {
      return (state = { ...state, ...action.payload });
    },
    clearMenuList: (state) => {
      state.menuList = [];
      store2.remove("menus");
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理原有的getMenuList
      .addCase(getMenuList.fulfilled, (state, action) => {
        if (action.payload) {
          const menuList = action.payload.data.map((item) => {
            return {
              ...item,
              auth: boolStr2Boolean(item.auth),
              hidden: boolStr2Boolean(item.hidden),
              routes: item.routes.map((route) => {
                return {
                  ...route,
                  auth: boolStr2Boolean(route.auth),
                  hidden: boolStr2Boolean(route.hidden)
                };
              })
            };
          });
          store2("menus", menuList);
          state.menuList = menuList;
        }
      })
      ;
  }
});

export const { toggleCollapsed, toggleIdentityList, toggleLevelList, clearMenuList } =
  appSlice.actions;

export default appSlice.reducer;
